<template>
    <div class="h-full flex flex-col bg-white p-4">
        <h1 class="text-lg font-semibold mb-4">Lista de usuários bloqueados</h1>
        <ul v-if="!loading" :class="`h-full ${!listUsers?.length ? 'flex items-center' : ''} border border-gray-300 rounded-md p-4`">
            <li v-if="listUsers?.length" v-for="user in listUsers" :key="user.id+'_'+user.name" class="flex items-center gap-4 border-b border-gray-300 p-2 cursor-pointer" >
                <div class="w-full flex justify-between gap-4">
                    <div class="w-1/2 grid grid-cols-3 gap-2">
                        <p class="col-span-2 font-semibold flex items-center">{{ user?.name }}</p>
                        <p class="flex items-center">{{ user?.department }}</p>
                    </div>
                    <el-row class="d-flex">
                        <el-button type="primary" size="large" @click="unblockUser(user)">Desbloquear</el-button>
                    </el-row>
                </div>
            </li>
            <li v-else-if="!listUsers?.length">
                <p class="text-red-500">Não existem usuários bloqueados.</p>
            </li>
        </ul>
        <ul v-else class="flex justify-center items-center h-full"> 
            <li>
                <el-col :span="24" class="flex flex-col items-start">
                    <SkeletonTable :total="10" />
                </el-col>
            </li>
        </ul>
    </div>
</template>

<script>
import UserService from "@/services/user.service"
import SkeletonTable from '@/components/intranet/SkeletonTable.vue'
import { notificationSuccess } from '@/utils/notification'
export default {
    name: "BlockedUser",
    components: {
        SkeletonTable
    },
    data() {
        return {
            loading: true,
            listUsers: [],
        };
    },
    methods: {
        getUsers() {
            this.loading = true
            this.userService.searchAll({user_blocked: true})
            .then(data => {
                this.listUsers = data
                this.loading = false
            })
        },
        unblockUser(user) {
            this.userService.update({id: user.id, data: { user_blocked: false }})
            .then(() => {
                notificationSuccess('Usuário desbloqueado com sucesso!')
                this.getUsers()
            })
        }
    },
    created() {
        this.userService = new UserService()
    },
    mounted() {
        this.getUsers()
    }
};
</script>